module.exports = __webpack_public_path__ + "static/media/11.a20428fe.jpg";